import { cn } from '@/lib/utils';

interface LogPulseLogoProps {
  className?: string;
  mono?: boolean;
}

export function LogPulseLogo({ className, mono = false }: LogPulseLogoProps) {
  // primary-500: leesbaar op zowel de lichte als donkere header
  const color = mono ? 'currentColor' : '#3B9C93';

  return (
    <svg
      className={cn('h-6 w-6', className)}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 16H8L11 6L16 26L21 12L24 20L26 16H30"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
